'use client';
import { GENERIC_FLAGGED_MESSAGE } from '@ui/components/organisms/message/message.constants';
import Link from 'next/link';
import { buildCommunityGuidelinesHref } from './community-guidelines-href';

type MessageBlockedProp = {
  userType: string;
  /** Render the guidelines pointer as a button to avoid a nested <a> when the banner sits inside a post-card link. */
  insideLink?: boolean;
  /** Lets the guidelines page resolve the creator header. */
  creatorId?: string;
};

export const MessageBlocked = ({ userType, insideLink, creatorId }: MessageBlockedProp) => {
  const href =
    userType === 'creator'
      ? '/dashboard/community-guidelines'
      : buildCommunityGuidelinesHref(creatorId);

  return (
    <div className="bg-korLightOrange text-korDarkGrey/80 rounded-md p-4 text-xs shadow-inner">
      {GENERIC_FLAGGED_MESSAGE}{' '}
      {insideLink ? (
        <button
          type="button"
          className="font-bold underline"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = href;
          }}>
          read guidelines
        </button>
      ) : (
        <Link className="font-bold underline" href={href}>
          read guidelines
        </Link>
      )}
    </div>
  );
};
